import axios from 'axios';

import AuthenticationService from './AuthenticationService';
import store from '../store';
import router from '../router';
import env from '../../config/env.json';

const instance = axios.create({
  baseURL: env.serverUri,
});

/**
 * Response interceptor to validate different http status.
 *
 * @remarks
 * If an error occurs from the backend, the user is redirected or it is displayed as a notification.
 *
 * @returns rejected error
 */
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.status || (error.status >= 500 && error.status <= 599)) {
      router.push('/internal-server-error');
    }
    switch (error.response.status) {
      case 403:
        router.push('/forbidden');
        break;
      case 404:
        router.push('/not-found');
        break;
      case 400:
        store.dispatch('showNotification', {
          message: '400 Bad Request',
          type: 'alert',
        });
        break;
      default:
        return Promise.reject(error);
    }
  },
);

/**
 * Request interceptor which appends the JWT access token to all backend requests.
 *
 * @returns request
 */
instance.interceptors.request.use(async (request) => {
  const token = `Bearer ${await AuthenticationService.getAccessToken()}`;
  if (request && request.headers) {
    request.headers.Authorization = token;
  }
  return request;
});

export default instance;
